import { Injectable } from '@angular/core';
import { ExportTableUtil } from 'src/app/shared/util/export-table.utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { WorksheetResponse } from '../worksheet/models/worksheet-response.modal';
import { SharedService } from './shared.service';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { ICommentModel } from 'src/app/shared/models/i-comment-modal';
@Injectable({
  providedIn: 'root',
})
export class ExportTableService {
  worksheetdata!: WorksheetResponse;
  headerValue: any;
  rowValue: any;
  notesUpdateBy: string | undefined = '';
  noteText: string | undefined = '';
  soilType: string;
  filenamelist: any;
  citylocation?: string;
  selectedSountry = '';
  SelectedState = '';
  SelectSoilType = '';
  constructor(private snackBar: MatSnackBar, private sharedService: SharedService) {
    (window as any).exportWSTable = this.exportWSTable.bind(this);
    (window as any).downloadFileData = this.downloadFileData.bind(this);
  }

  // Generate Worksheet open new window tab and export donwload//
  private getTableName(headerType: string): string {
    const nameMapping: { [key: string]: string } = {
      asRecivedWorksheets: 'As Received Worksheet',
      moistureWorksheets: 'Moisture Worksheet',
      nativeSoilWorksheets: 'Native Soil Worksheet',
      proctorWorksheets: 'Proctor Worksheet',
      precast: 'Precast Worksheet',
    };
    return (
      nameMapping[headerType]
      || headerType
        .replace('Worksheets', '')
        .replace(/([A-Z])/g, ' $1')
        .trim()
    );
  }

  private generateNativeSoilTable(headerData: any, rowData: any): string {
    let tableHtml = '';

    ['asRecivedWorksheets', 'moistureWorksheets', 'nativeSoilWorksheets', 'proctorWorksheets'].forEach((type) => {
      if (headerData[type] && rowData[type] && rowData[type].length > 0) {
        const tableName = this.getTableName(type);
        tableHtml += `<h2>${tableName}</h2>`;
        tableHtml += '<table>';
        tableHtml += '<thead><tr>';
        headerData[type].forEach((header: any) => {
          tableHtml += `<th>${header.displayName}${header.units ? ` ${header.units}` : ''}</th>`;
        });
        tableHtml += '</tr></thead><tbody>';
        rowData[type].forEach((row: any) => {
          tableHtml += '<tr>';
          headerData[type].forEach((header: any) => {
            let cellValue = row[header.key] !== undefined && row[header.key] !== null ? row[header.key] : '';
            if (header.key === 'compactionEffort' && cellValue === 0) {
              cellValue = "Dump";
            }
            if (header.key === 'effort' && cellValue === 0) {
            cellValue = "Dump";
            }
            tableHtml += `<td>${cellValue}</td>`;
          });
          tableHtml += '</tr>';
        });
        tableHtml += '</tbody></table>';
      }
    });

    return tableHtml;
  }

  private generatePrecastTable(headerData: any[], rowData: any[]): string {
    let tableHtml = '';

    if (headerData && rowData && rowData.length > 0) {
      const tableName = this.getTableName('precast');
      tableHtml += `<h2>${tableName}</h2>`;
      tableHtml += '<table border="1" cellspacing="0" cellpadding="4">';
      tableHtml += '<thead><tr>';

      // Columns to completely remove
      const removeColumns = ['volume', 'loss', 'assignedTo', 'status'];
      const filteredHeaderData = headerData.filter(h => !removeColumns.includes(h.key));
      filteredHeaderData.forEach((header) => {
        tableHtml += `<th>${header.displayName}${header.units ? ` ${header.units}` : ''}</th>`;
      });
      tableHtml += '</tr></thead><tbody>';

      // Columns to blank for repeated group-level values (excluding removed columns)
      const blankColumnKeys: string[] = [
        'inHouseId',
        'castDate',
        'sampleId',
        'mixDesignCode',
        'sampleType',
        'mixId',
        'tare',
        'dryPlusTare',
        'drySoilWeight',
        'sampleDiameter',
        'sampleHeight',
        'dryTr',
        'density'
      ];

      const blankColumnIndexes: number[] = blankColumnKeys
        .map(key => filteredHeaderData.findIndex(h => h.key === key))
        .filter(i => i !== -1);

      let lastGroupId: string | null = null;

      rowData.forEach((row, index) => {
        const nextRow = rowData[index + 1];
        let rowStyle = '';

        if (nextRow && row.preCastSampleId !== nextRow.preCastSampleId) {
          rowStyle = 'border-bottom: 2px solid black;';
        }
        tableHtml += `<tr style="${rowStyle}">`;

        filteredHeaderData.forEach((header, colIndex) => {
          let cellValue = row[header.key] !== undefined && row[header.key] !== null ? row[header.key] : '';
          // Blank repeated values for specified columns
          if (lastGroupId === row.groupId && blankColumnIndexes.includes(colIndex)) {
            cellValue = '';
          }

          tableHtml += `<td>${cellValue}</td>`;
        });

        tableHtml += '</tr>';
        lastGroupId = row.groupId;
      });
      tableHtml += '</tbody></table>';
    }
    return tableHtml;
  }

  // New one-to-many Native Soil and Precast worksheets: one row per test result, with the worksheet's thick border
  // between samples and (Native Soil only) dotted border between compaction efforts of the same sample
  private generateTestResultWorksheetTable(tableName: string, headerData: any[], rowData: any[]): string {
    if (!headerData?.length || !rowData?.length) {
      return '';
    }

    let tableHtml = `<h2>${tableName}</h2>`;
    tableHtml += '<table><thead><tr>';
    headerData.forEach((header) => {
      tableHtml += `<th>${header.displayName}</th>`;
    });
    tableHtml += '</tr></thead><tbody>';

    rowData.forEach((row, index) => {
      let cellStyle = '';
      if (row.lastRowOfSample && index < rowData.length - 1) {
        cellStyle = 'border-bottom: 3px solid #8b8b8b;';
      } else if (row.lastRowOfEffort) {
        cellStyle = 'border-bottom: 2px dotted #8b8b8b;';
      }
      tableHtml += '<tr>';
      headerData.forEach((header) => {
        tableHtml += `<td style="${cellStyle}">${row[header.key] ?? ''}</td>`;
      });
      tableHtml += '</tr>';
    });
    tableHtml += '</tbody></table>';

    return tableHtml;
  }

  openInNewTab(
    headerData: any,
    rowData: any,
    worksheetRecords: any,
    notesUpdatedBy: any,
    text: any,
    soilType: string,
  ): void {
    this.worksheetdata = worksheetRecords;
    this.headerValue = headerData;
    this.rowValue = rowData;
    this.notesUpdateBy = notesUpdatedBy;
    this.noteText = text;
    this.soilType = soilType;
    // The new precast worksheet shares the precast header and cover with the old one
    const isPrecast = soilType === 'precast' || soilType === 'precast-worksheet';
    let tableHtml = '';
    if (soilType === 'nativesoil') {
      tableHtml = this.generateNativeSoilTable(headerData, rowData);
    } else if (soilType === 'native-soil') {
      tableHtml = this.generateTestResultWorksheetTable(this.getTableName('nativeSoilWorksheets'), headerData, rowData);
    } else if (soilType === 'precast-worksheet') {
      tableHtml = this.generateTestResultWorksheetTable(this.getTableName('precast'), headerData, rowData);
    } else if (soilType === 'precast') {
      tableHtml = this.generatePrecastTable(headerData, rowData);
    }

    const formattedSampleReceivedDate = DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.sampleReceivedDate, 'MM/dd/yyyy');
    const formattedInstructionsConfirmedAt = DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.instructionsConfirmedAt, 'MM/dd/yyyy');
    const formattedDueDate = DateTimeUtils.getLocalDateTimeFromUTCDate(worksheetRecords.project.dueDate, 'MM/dd/yyyy');
    const headerHtml = `
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-bottom: 20px;">
        <h1 style="margin: 0; font-size: 24px;">Excel Preview</h1>
        <div style="display: flex; gap: 10px;">
          <button id="openCoverPreviewBtn" style="
            padding: 10px 20px; 
            font-size: 16px; 
            white-space: nowrap;
            color: #DD3333;
            background-color: white;
            border: 2px solid #DD3333;
            border-radius: 4px;
            cursor: pointer;
          ">
            PRINT COVER
          </button>
          <button id="downloadBtn" style="
            padding: 10px 20px; 
            font-size: 16px; 
            white-space: nowrap;
            color: #DD3333;
            background-color: white;
            border: 2px solid #DD3333;
            border-radius: 4px;
            cursor: pointer;
          ">
            DOWNLOAD XLSX FILE
          </button>
        </div>
      </div>
    `;

    const projectFields = [
      ['Project Name:', worksheetRecords.project.projectName || ''],
      ['Project Reference:', worksheetRecords.project.referenceId || ''],
      ['Project Number:', worksheetRecords.project.projectNumber || ''],
      ['Project Location:', worksheetRecords.project.projectLocation || ''],
      ['PO/Job Number:', worksheetRecords.project.jobNumber || ''],
      ['Rushed:', worksheetRecords.project.rushTesting ? 'TRUE' : 'FALSE'],
      ['Company Name:', worksheetRecords.company.name || ''],
      ['Customer Name:', worksheetRecords.company.contactName || ''],
      ['Customer Email:', worksheetRecords.company.emails || ''],
      ['Customer Contact:', worksheetRecords.company.contactNumber || ''],
      [
        (isPrecast ? 'Pre-Approval:' : 'Geotherm Field Testing:'),
        (isPrecast
          ? (worksheetRecords.project.preApproval === true ? 'TRUE' : worksheetRecords.project.preApproval === false ? 'FALSE' : worksheetRecords.project.preApproval || '')
          : (worksheetRecords.project.geothermField === true ? 'TRUE' : worksheetRecords.project.geothermField === false ? 'FALSE' : worksheetRecords.project.geothermField || '')
        )
      ],
    ];

    const secondCoulmn: [string, string][] = [
      ['Sample Received Date:', formattedSampleReceivedDate || ''],
      ['Instructions Confirmed At:', formattedInstructionsConfirmedAt || ''],
      ['Due Date:', formattedDueDate || ''],
      ['Oven Date:', worksheetRecords.project.ovenDate || ''],
      ['Wet Test Data:', worksheetRecords.project.wetTestData || ''],
      ['Dry Test Data:', worksheetRecords.project.dryTestData || ''],
      ['Notes Updated By:', notesUpdatedBy || ''],
      ['Note Text:', text || ''],
      ['Storage Location:', worksheetRecords.project.storageCompartment || ''],
    ];

    const items = [
      { id: 1, type: 'Concrete' },
      { id: 2, type: 'FTB' },
      { id: 3, type: 'Grout/Slurry' },
      { id: 4, type: 'Other' }
    ];

    const typePriority = items.map(item => item.type);
    const sortedComments = [...(worksheetRecords.comments ?? [])].sort((a, b) => {
      const aIndex = typePriority.indexOf(a.sampleTypeName || '');
      const bIndex = typePriority.indexOf(b.sampleTypeName || '');
      const fallback = typePriority.length;
      return (aIndex === -1 ? fallback : aIndex) - (bIndex === -1 ? fallback : bIndex);
    });

    if (sortedComments?.length) {
      sortedComments.forEach((c: ICommentModel) => {
        secondCoulmn.push([c.sampleTypeName || '', c.projectComment || '']);
      });
    }

    const maxRows = Math.max(projectFields.length, secondCoulmn.length);
    const coverHtml = this.buildCoverPreviewHtml(this.worksheetdata, isPrecast ? 'precast' : this.soilType);

    const rows: string[] = Array.from({ length: maxRows }, (_, i) => {
      const leftLabel = projectFields[i]?.[0] || '';
      const leftValue = projectFields[i]?.[1] || '';
      const rightLabel = secondCoulmn[i]?.[0] || '';
      const rightValue = secondCoulmn[i]?.[1] || '';

      return `
        <tr style="border: none;">
          <td style="vertical-align: top; padding: 4px 4px 4px 8px; ">${leftLabel}</td>
          <td style="padding: 4px 8px 4px 4px; ">${leftValue}</td>
          <td style="vertical-align: top; padding: 4px 4px 4px 8px; ">${rightLabel}</td>
          <td style="padding: 4px 8px 4px 4px; ">${rightValue}</td>
          <td style="border: none; width: 500px; padding: 0; margin: 0;"></td>
        </tr>
      `;
    });

    const projectInfoHtml = `
      <table style="width: 100%; border-collapse: collapse; border: none;">
        <tbody>
          ${rows.join('')}
        </tbody>
      </table>
    `;

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Excel Preview</title>
        <style>
          body { font-family: Roboto, sans-serif; margin: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; }
          th { background-color: #f2f2f2; text-align: left; }

          /* Hide buttons during print */
          @media print {
            #openCoverPreviewBtn,
            #downloadBtn {
              display: none !important;
            }
          }
        </style>
      </head>
      <body>
        ${headerHtml}
        ${projectInfoHtml}
        ${tableHtml}
        <script>
          // Button click handlers
          document.getElementById('downloadBtn').addEventListener('click', function() {
            if (window.opener && typeof window.opener.exportWSTable === 'function') {
              window.opener.exportWSTable();
            } else {
              alert('Export function not available.');
            }
          });

          document.getElementById('openCoverPreviewBtn')?.addEventListener('click', function () {
            const win = window.open('', '_blank');
            if (!win) return;
            win.document.open();
            win.document.write(\`${coverHtml}\`);
            win.document.close();
          });

          // Detect print via Ctrl+P or browser print
          function handleBeforePrint() {
            const coverBtn = document.getElementById('openCoverPreviewBtn');
            const downloadBtn = document.getElementById('downloadBtn');
            if (coverBtn) coverBtn.style.display = 'none';
            if (downloadBtn) downloadBtn.style.display = 'none';
          }

          function handleAfterPrint() {
            const coverBtn = document.getElementById('openCoverPreviewBtn');
            const downloadBtn = document.getElementById('downloadBtn');
            if (coverBtn) coverBtn.style.display = '';
            if (downloadBtn) downloadBtn.style.display = '';
          }

          window.addEventListener('beforeprint', handleBeforePrint);
          window.addEventListener('afterprint', handleAfterPrint);
        </script>
      </body>
      </html>
    `;

    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close();
    }
  }

  public getSampleTypeCode(worksheetData: any, soilType: string): string {
    if (soilType !== 'precast') {
      return 'NS';
    }
    const typesSet = new Set<string>();
    worksheetData.comments.forEach((comment: ICommentModel) => {
      const typeName = comment.sampleTypeName?.toLowerCase();
      if (!typeName) return;

      if (typeName === 'concrete') typesSet.add('C');
      else if (typeName === 'ftb') typesSet.add('F');
      else if (typeName === 'grout/slurry') typesSet.add('G');
      else if (typeName === 'other') typesSet.add('O');
    });

    const order = ['C', 'F', 'G', 'O'];
    const sortedTypes = Array.from(typesSet).sort((a, b) => order.indexOf(a) - order.indexOf(b));
    return sortedTypes.join('');
  }

  public buildCoverPreviewHtml(worksheetData: any, soilType: string): string {
    if (!worksheetData) return '';
    const project = worksheetData.project;
    const company = worksheetData.company;
    const formatDate = (date?: string, format = 'MM/dd/yyyy') =>
    date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '';
    let sampleType = this.getSampleTypeCode(worksheetData, soilType);
    const formattedReportCreatedDate = formatDate(new Date().toISOString(), 'MM/dd/yyyy');
    const formattedReportSubmittalDate = formatDate(project.dueDate, 'MM/dd/yyyy');
    const formattedDueDate = formatDate(project.dueDate, 'MMddyy');
    const rawFileName = [
      company.name,
      project.projectName,
      project.projectNumber,
      sampleType,
      formattedDueDate,
    ].filter(Boolean).join('-');

    const fileNameHtml = this.splitFileNameForCover(rawFileName);
    const isRush = project.rushTesting;
    return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${project.referenceId} Report Cover</title>
      <style>
        body {
          font-family: Roboto, Arial, sans-serif;
          margin: 40px;
          color: #000;
        }

        h2 {
          text-align: center;
          margin-bottom: 30px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }

        td {
          border: 1px solid #000;
          padding: 12px;
          vertical-align: middle;
          font-size: 14px;
        }

        .label {
          width: 30%;
          font-weight: 600;
        }

        .center {
          text-align: center;
        }

        @media print {
          body {
            margin: 20mm;
          }
        }

        .seamless-textarea {
          width: 100%;
          min-height: 60px;
          border: none;
          outline: none;
          resize: none; /* prevent manual resize */
          font-family: inherit;
          font-size: 14px;
          line-height: 1.6;
          background: transparent;
          padding: 0;
          color: #7030A0;
          overflow: hidden; /* hide scrollbar */
        }

        .seamless-textarea::-webkit-scrollbar {
          width: 0px; /* Chrome/Safari */
          background: transparent;
        }

        @media print {
          .seamless-textarea {
            border: none;
            outline: none;
          }
        }

        .seamless-input {
          width: 100%;
          border: none;
          outline: none;
          font-family: inherit;
          font-size: 14px;
          background: transparent;
          padding: 0;
          color: #000;
        }

        @media print {
          .seamless-input {
            border: none;
            outline: none;
          }
        }

        .rush-print-hide { visibility: hidden; }
        .mix-design { padding: 0; important; }

        .purple-text {
          color: blue;
        }

        @media print {
          .print-outline-btn { visibility: hidden;}
        }
      </style>
    </head>
    <body>
    <div style="display: grid; grid-template-columns: auto 1fr auto; align-items: center; margin-bottom: 20px;">
      <button
        id="print"
        onclick="
          const t=document.getElementById('notesTextarea');
          if(!t.value||t.value.trim()==='Enter notes here'){t.style.display='none'}
          window.print();
          t.style.display='';
        "
        style="
          padding: 10px 20px;
          font-size: 16px;
          white-space: nowrap;
          color: #DD3333;
          background-color: white;
          border: 2px solid #DD3333;
          border-radius: 4px;
          cursor: pointer;
        "
        class="print-outline-btn">
        PRINT
      </button>

      <h2 style="margin: 0; text-align: center;">
        ${soilType === 'precast' ? ` PRECAST` : `NATIVE SOIL`}
      </h2>

      <h2 class="${!isRush ? 'rush-print-hide' : ''}"style="margin: 0; color: rgba(255, 0, 0); justify-self: end;">
        RUSH
      </h2>
    </div>

    <table>
      <tr>
        <td class="label">File Name</td>
        <td colspan="4">
          <div class="seamless-input purple-text" contenteditable="true"
          style="white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;">${fileNameHtml}</div>
        </td>
      </tr>

      <tr>
        <td class="label">Report Created on</td>
        <td colspan="4">
          <input
            class="seamless-input purple-text"
            value="${formattedReportCreatedDate || ''}"
          />
        </td>
      </tr>

      <tr>
        <td class="label">Report Submittal Date</td>
        <td colspan="4">
          <input
            class="seamless-input purple-text"
            value="${formattedReportSubmittalDate || ''}"
          />
        </td>
      </tr>

      <tr>
        <td class="label" rowspan="2">Reviewed by</td>
        <td><strong>Nimesh</strong></td>
        <td><strong>Deepak</strong></td>
        <td><strong>Nandu</strong></td>
        <td><strong>Joe</strong></td>
      </tr>

      <tr>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td class="label">PDF on Server Dated</td>
        <td colspan="4">&nbsp;</td>
      </tr>

      <tr>
        <td class="label" rowspan="2">Invoiced / Billed</td>
        <td colspan="2"><strong>Pre-Pay</strong></td>
        <td colspan="2"><strong>Net 30/45/60</strong></td>
      </tr>
      <tr>
        <td colspan="2">&nbsp;</td>
        <td colspan="2">&nbsp;</td>
      </tr>

      <tr>
        <td class="label">Invoice & Report Sent</td>
        <td colspan="4">&nbsp;</td>
      </tr>

      ${soilType === 'nativesoil' || soilType === 'native-soil' ? '' :
        `<tr>
          <td class="label">Mix Design</td>
          <td class="mix-design" colspan="4">
            <table style="width: 100%; border-collapse: collapse; border: none; text-align: left;">
              <tr>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="newMix" />
                  <label for="newMix"><strong>New Mix</strong></label>
                </td>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="previousMix" />
                  <label for="previousMix"><strong>Previous Mix</strong></label>
                </td>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="geothermMix" />
                  <label for="geothermMix"><strong>Geotherm Mix</strong></label>
                </td>
              </tr>
            </table>
          </td>
        </tr>`
      }

      <tr>
        <td class="label">Notes</td>
        <td colspan="4">
          <textarea
            id="notesTextarea"
            class="seamless-textarea purple-text"
            oninput="this.style.height='auto'; this.style.height=this.scrollHeight+'px';"
            onfocus="if(this.value==='Enter notes here'){ this.value='' }"
          >Enter notes here</textarea>
        </td>
      </tr>

      <tr>
        <td class="label">Project Reference</td>
        <td class="purple-text" colspan="4">${project.referenceId}</td>
      </tr>
    </table>

    </body>
    </html>
    `;
  }

  private getMixDesignCodeForName(worksheetData: any): string {
    if (!worksheetData?.project?.preApproval) return '';
    const sample = (worksheetData?.samples ?? []).find((s: any) => !!s?.mixDesignCode);
    return sample?.mixDesignCode ?? '';
  }

  public buildCoverPreviewHtmlPrecast(worksheetData: any, soilType: string): string {
    if (!worksheetData) return '';
    const { project } = worksheetData;
    const { company } = worksheetData;
    const formatDate = (date?: string, format = 'MM/dd/yyyy') => (date ? DateTimeUtils.getLocalDateTimeFromUTCDate(date, format).toString() : '');
    const sampleType = this.getSampleTypeCode(worksheetData, soilType);
    const formattedReportCreatedDate = formatDate(new Date().toISOString(), 'MM/dd/yyyy');
    const formattedReportSubmittalDate = formatDate(project.dueDate, 'MM/dd/yyyy');
    const formattedDueDate = formatDate(project.dueDate, 'MMddyy');
    const rawFileName = [
      company.name,
      project.projectName,
      project.projectNumber,
      this.getMixDesignCodeForName(worksheetData),
      sampleType,
      project.referenceId,
      formattedDueDate,
      project.preApproval ? 'PA' : '',
    ].filter(Boolean).join('-');

    const fileNameHtml = this.splitFileNameForCover(rawFileName);
    const isRush = project.rushTesting;
    return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${project.referenceId} Report Cover</title>
      <style>
        body {
          font-family: Roboto, Arial, sans-serif;
          margin: 40px;
          color: #000;
        }

        h2 {
          text-align: center;
          margin-bottom: 30px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }

        td {
          border: 1px solid #000;
          padding: 12px;
          vertical-align: middle;
          font-size: 14px;
        }

        .label {
          width: 30%;
          font-weight: 600;
        }

        .center {
          text-align: center;
        }

        @media print {
          body {
            margin: 20mm;
          }
        }

        .seamless-textarea {
          width: 100%;
          min-height: 60px;
          border: none;
          outline: none;
          resize: none; /* prevent manual resize */
          font-family: inherit;
          font-size: 14px;
          line-height: 1.6;
          background: transparent;
          padding: 0;
          color: #7030A0;
          overflow: hidden; /* hide scrollbar */
        }

        .seamless-textarea::-webkit-scrollbar {
          width: 0px; /* Chrome/Safari */
          background: transparent;
        }

        @media print {
          .seamless-textarea {
            border: none;
            outline: none;
          }
        }

        .seamless-input {
          width: 100%;
          border: none;
          outline: none;
          font-family: inherit;
          font-size: 14px;
          background: transparent;
          padding: 0;
          color: #000;
        }

        @media print {
          .seamless-input {
            border: none;
            outline: none;
          }
        }

        .rush-print-hide { visibility: hidden; }
        .mix-design { padding: 0; important; }

        .purple-text {
          color: blue;
        }

        @media print {
          .print-outline-btn { visibility: hidden;}
        }
      </style>
    </head>
    <body>
    <div style="display: grid; grid-template-columns: auto 1fr auto; align-items: center; margin-bottom: 20px;">
      <button
        id="print"
        onclick="
          const t=document.getElementById('notesTextarea');
          if(!t.value||t.value.trim()==='Enter notes here'){t.style.display='none'}
          window.print();
          t.style.display='';
        "
        style="
          padding: 10px 20px;
          font-size: 16px;
          white-space: nowrap;
          color: #DD3333;
          background-color: white;
          border: 2px solid #DD3333;
          border-radius: 4px;
          cursor: pointer;
        "
        class="print-outline-btn">
        PRINT
      </button>

      <h2 style="margin: 0; text-align: center;">
        ${soilType === 'precast' ? ' PRECAST' : 'NATIVE SOIL'}
      </h2>

      <h2 class="${!isRush ? 'rush-print-hide' : ''}"style="margin: 0; color: rgba(255, 0, 0); justify-self: end;">
        RUSH
      </h2>
    </div>

    <table>
      <tr>
        <td class="label">File Name</td>
        <td colspan="4">
          <div class="seamless-input purple-text" contenteditable="true"
          style="white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;">${fileNameHtml}</div>
        </td>
      </tr>

      <tr>
        <td class="label">Report Created on</td>
        <td colspan="4">
          <input
            class="seamless-input purple-text"
            value="${formattedReportCreatedDate || ''}"
          />
        </td>
      </tr>

      <tr>
        <td class="label">Report Submittal Date</td>
        <td colspan="4">
          <input
            class="seamless-input purple-text"
            value="${formattedReportSubmittalDate || ''}"
          />
        </td>
      </tr>

      <tr>
        <td class="label" rowspan="2">Reviewed by</td>
        <td><strong>Nimesh</strong></td>
        <td><strong>Deepak</strong></td>
        <td><strong>Nandu</strong></td>
        <td><strong>Joe</strong></td>
      </tr>

      <tr>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td class="label">PDF on Server Dated</td>
        <td colspan="4">&nbsp;</td>
      </tr>

      <tr>
        <td class="label" rowspan="2">Invoiced / Billed</td>
        <td colspan="2"><strong>Pre-Pay</strong></td>
        <td colspan="2"><strong>Net 30/45/60</strong></td>
      </tr>
      <tr>
        <td colspan="2">&nbsp;</td>
        <td colspan="2">&nbsp;</td>
      </tr>

      <tr>
        <td class="label">Invoice & Report Sent</td>
        <td colspan="4">&nbsp;</td>
      </tr>

      ${soilType === 'nativesoil' ? ''
    : `<tr>
          <td class="label">Mix Design</td>
          <td class="mix-design" colspan="4">
            <table style="width: 100%; border-collapse: collapse; border: none; text-align: left;">
              <tr>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="newMix" />
                  <label for="newMix"><strong>New Mix</strong></label>
                </td>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="previousMix" />
                  <label for="previousMix"><strong>Previous Mix</strong></label>
                </td>
                <td style="border: none; padding: 4px;">
                  <input type="checkbox" id="geothermMix" />
                  <label for="geothermMix"><strong>Geotherm Mix</strong></label>
                </td>
              </tr>
            </table>
          </td>
        </tr>`
}

      <tr>
        <td class="label">Notes</td>
        <td colspan="4">
          <textarea
            id="notesTextarea"
            class="seamless-textarea purple-text"
            oninput="this.style.height='auto'; this.style.height=this.scrollHeight+'px';"
            onfocus="if(this.value==='Enter notes here'){ this.value='' }"
          >Enter notes here</textarea>
        </td>
      </tr>

      <tr>
        <td class="label">Project Reference</td>
        <td class="purple-text" colspan="4">${project.referenceId}</td>
      </tr>
    </table>

    </body>
    </html>
    `;
  }

  private splitFileNameForCover(name: string, maxLen = 49): string {
    if (name.length <= maxLen) return name;
    const breakIndex = Math.max(
      name.lastIndexOf('-', maxLen),
      name.lastIndexOf(' ', maxLen)
    );
    const index = breakIndex > 0 ? breakIndex : maxLen;

    return (
      name.slice(0, index).trim() +
      '<br>' +
      name.slice(index + 1).trim()
    );
  }

  exportWSTable() {
    const { projectName } = this.worksheetdata.project;
    const { projectNumber } = this.worksheetdata.project;
    const { jobNumber } = this.worksheetdata.project;
    const companyName = this.worksheetdata.company.name
    const { sampleReceivedDate } = this.worksheetdata.project;
    const { instructionsConfirmedAt } = this.worksheetdata.project;
    const { dueDate } = this.worksheetdata.project;
    const { ovenDate } = this.worksheetdata.project;
    const { wetTestData } = this.worksheetdata.project;
    const { dryTestData } = this.worksheetdata.project;
    const { geothermField } = this.worksheetdata.project;
    const { rushTesting } = this.worksheetdata.project;
    const { noteText } = this;
    const notesUpdatedBy = this.notesUpdateBy;
    const customerName = this.worksheetdata.company.contactName;
    const customerEmail = this.worksheetdata.company.emails;
    const customerContactNumber = this.worksheetdata.company.contactNumber;
    const { comments } = this.worksheetdata;
    const { projectLocation } = this.worksheetdata.project
    const { referenceId } = this.worksheetdata.project;
    if (this.soilType === 'nativesoil') {
      ExportTableUtil.exportWorksheetTable(
        this.headerValue,
        this.rowValue,
        projectName,
        projectNumber,
        companyName,
        sampleReceivedDate,
        instructionsConfirmedAt,
        dueDate,
        ovenDate,
        wetTestData,
        dryTestData,
        geothermField,
        rushTesting,
        noteText,
        notesUpdatedBy,
        customerName,
        customerEmail,
        customerContactNumber,
        comments,
        jobNumber,
        projectLocation,
        referenceId
      );
    } else if (this.soilType === 'native-soil') {
      ExportTableUtil.exportNativeSoilWorksheetTable(
        this.headerValue,
        this.rowValue,
        projectName,
        projectNumber,
        companyName,
        sampleReceivedDate,
        instructionsConfirmedAt,
        dueDate,
        ovenDate,
        wetTestData,
        dryTestData,
        geothermField,
        rushTesting,
        noteText,
        notesUpdatedBy,
        customerName,
        customerEmail,
        customerContactNumber,
        comments,
        jobNumber,
        projectLocation,
        referenceId
      );
    } else if (this.soilType === 'precast') {
      ExportTableUtil.exportPrecastWorksheetTable(
        this.headerValue,
        this.rowValue,
        projectName,
        projectNumber,
        companyName,
        sampleReceivedDate,
        instructionsConfirmedAt,
        dueDate,
        ovenDate,
        wetTestData,
        dryTestData,
        geothermField,
        rushTesting,
        noteText,
        notesUpdatedBy,
        customerName,
        customerEmail,
        customerContactNumber,
        comments,
        jobNumber,
        projectLocation,
        referenceId
      );
    } else if (this.soilType === 'precast-worksheet') {
      ExportTableUtil.exportPrecastTestResultWorksheetTable(
        this.headerValue,
        this.rowValue,
        projectName,
        projectNumber,
        companyName,
        sampleReceivedDate,
        instructionsConfirmedAt,
        dueDate,
        ovenDate,
        wetTestData,
        dryTestData,
        geothermField,
        rushTesting,
        noteText,
        notesUpdatedBy,
        customerName,
        customerEmail,
        customerContactNumber,
        comments,
        jobNumber,
        projectLocation,
        referenceId
      );
    }
  }

  // Geo Map Location Download Data //
  /**
   * Opens a new tab displaying a list of filenames and provides a button to download them as a text file.
   *
   * This function takes a list of filenames and a city name to generate an HTML page
   * that displays the filenames in a numbered list. It includes a button to download
   * the filenames as a .txt file.
   * */

  downloadTxtFile(filename: any, city: string | undefined, country :string, state:string, soiltype:string) {
    this.filenamelist = filename;
    this.citylocation = city;
    this.selectedSountry = country;
    this.SelectedState = state;
    this.SelectSoilType = soiltype;
    if (!Array.isArray(this.filenamelist) || this.filenamelist.length === 0) {
      this.snackBar.open(messagesConfig.fileNameListEmpty.message, 'DONE', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['default-snackbar'],
      });
      return;
    }
    const fileContent = this.filenamelist
      .map((filenames: any, index: number) => `${index + 1}. ${filenames}`)
      .join('<br>');
    const newTab = window.open('', '_blank');

    if (newTab) {
      newTab.document.write(`
      <html>
        <head>
          <title>${this.citylocation} FileName(s) List</title>
          <style>
            body {
              font-family: Arial, sans-serif;
            }
            h1 {
              margin-bottom: 10px;
            }
            .download-button {
              padding: 10px 20px;
              right: 1%;
              position: absolute;
              color: #DD3333;
              align-items: center;
              background-color: white;
              border-radius: 4px;
              border: 2px solid #DD3333;
              cursor:pointer;
            }

          </style>
        </head>
        <body>
          <h1>${this.citylocation} Location FileName(s) List
            <button id="downloadBtn"class="download-button" >DOWNLOAD TXT FILE</button>
          </h1>
          <p>${fileContent}</p>
          <script>
          document.getElementById('downloadBtn').addEventListener('click', function() {
            if (window.opener && typeof window.opener.downloadFileData === 'function') {
              window.opener.downloadFileData();
            } else {
              alert('Export function not available.');
            }
          });
        </script>
        </body>
      </html>
    `);
      newTab.document.close();
    }
  }

  /**
   * Downloads the file data as a text file.
   *
   * This function generates a text file from the contents of the `filenamelist` array.
   * The file is named based on the `citylocation` property and contains each item
   * from the `filenamelist` joined by newline characters.
   *  */
  downloadFileData() {
    // const fileContent = this.filenamelist.join('\n');
    const fileContent = this.filenamelist
      .map((filename: any, index: number) => `${index + 1}. ${filename}`)
      .join('\n');
    const blob = new Blob([fileContent], {
      type: 'text/plain',
    });
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = `${this.citylocation}-${this.selectedSountry}-${this.SelectedState}-${this.SelectSoilType}.txt`;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
